import { usePermissions } from '@front/hook/usePermissions';
import type { PropsWithChildren, ReactElement } from 'react';

/**
 * プロジェクト管理者（ProductAdmin）専用ページ用のガード。
 * 権限が無い場合は子要素を描画せず、権限不足のメッセージを表示する。
 * 子コンポーネント内の hooks も実行されないため、不要な API 呼び出し（403）も防げる。
 */
export function RequireProjectAdmin({ children }: PropsWithChildren): ReactElement {
  const { isProjectAdmin } = usePermissions();

  if (!isProjectAdmin) {
    return (
      <div className="rounded-lg border border-default bg-subtle-light p-6 text-center text-sm text-muted-light">
        この操作にはプロジェクト管理者権限が必要です
      </div>
    );
  }

  return <>{children}</>;
}
